import { AxiosResponse } from "axios";
import {
    apiGet,
    apiPost,
    apiDelete,
    apiPut,
    getGlobalStates,
} from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { GET_SAML_INTEGRATIONS, CREATE_SAML, UPDATE_SAML, DELETE_SAML } from "./identityProviderPath";
import usermgtStore from "../usermgtStore";
import { usermgtSliceActions } from "../usermgtSlice";
import { samlIdentityProviderSliceActions } from "../samlIdentityProviderSlice";
import { levelSliceActions } from "../levelSlice";
import {
    UpdateSamlIdentityProvider,
    DeleteSamlIdentityProvider,
    AddSamlIdentityProvider,
    SamlIdentityProvider,
    SamlIdentityProviderStatus,
    SamlIdentityProviderConfig,
    SamlIdentityProviders,
    getIdentityID,
    IDENTITY_PROVIDER_ERROR_KEY,
    isActiveServer,
} from "userful-chronos-app-common-js/dist/models/usermgt/samlIdentityProviders";
import { toast } from "react-toastify";
import { ConfirmationToastContentStore } from "../../../Container/ConfirmationToastContentStore";

const errorHandler = (err) => {
    console.debug("Error calling init app api ");
    console.debug(err);
};

const getError = (response: any) => {
    return {
        success: false,
        arg: response.data.arg ? response.data.arg : "",
        errorCode: response.data.errorCode ? response.data.errorCode : "",
        moduleID: response.data.moduleID ? response.data.moduleID : "",
        severity: response.data.severity ? response.data.severity : "",
        msg: response.data.unlocalizedMsg ? response.data.unlocalizedMsg : "",
    };
};

export const checkReponseIsValid = (name: string, response: AxiosResponse): boolean => {
    if (response.status >= 400) {
        console.log(`${name} error: ${response.status}`);
        return false;
    }
    if (!response.data || response.data.severity !== "SUCCESS") {
        console.log(`${name} empty response`);
        return false;
    }
    return true;
};

export const getSAMLDataFromServer = (token: string) => {
    const t1 = getGlobalStates().host + GET_SAML_INTEGRATIONS;

    apiGet(t1, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                samlIdentityProviderSliceActions.setSAMLData(getSAMLDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const addSAMLDataToServer = (token: string, data: AddSamlIdentityProvider) => {
    const t1 = getGlobalStates().host + CREATE_SAML;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("configure SAML ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                samlIdentityProviderSliceActions.setSAMLData(getSAMLDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`configure SAML `, response.data);
            const updatedData = response.data.arg as SamlIdentityProvider;
            const displayName = updatedData.config.filter((config) => config.id.value === updatedData.id.value)[0]
                .displayName;
            const customDisplay = ConfirmationToastContentStore(displayName, "Save");
            toast(customDisplay, { containerId: "confirmationContainer" });
            // for displaying if there is error while syncing users
            const syncData = response.data.arg;
            const syncResult = syncData.status.error === true ? syncData.status.message : null;
            if (syncResult) {
                const displayError = ConfirmationToastContentStore(syncData.provider.alias, "Custom", syncResult);
                toast(displayError, { containerId: "confirmationContainer" });
            }
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const updateSAMLDataToServer = (token: string, data: UpdateSamlIdentityProvider) => {
    const t1 = getGlobalStates().host + UPDATE_SAML;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("update SAML ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                samlIdentityProviderSliceActions.setSAMLData(getSAMLDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`update SAML`, response.data.arg);
            const customDisplay = ConfirmationToastContentStore(data.config[0].displayName, "Edit");
            toast(customDisplay, { containerId: "confirmationContainer" });
            // for displaying if there is error while syncing users
            const syncData = response.data.arg;
            const syncResult = syncData.status.error === true ? syncData.status.message : null;
            if (syncResult) {
                const displayError = ConfirmationToastContentStore(syncData.provider.alias, "Custom", syncResult);
                toast(displayError, { containerId: "confirmationContainer" });
            }
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const deleteSAMLDataToServer = (token: string, data: DeleteSamlIdentityProvider) => {
    const t1 = getGlobalStates().host + DELETE_SAML;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                samlIdentityProviderSliceActions.setSAMLData(getSAMLDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(samlIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const getSAMLDataAfterValidationCheck = (samlData): SamlIdentityProviders => {
    let updatedSAMLDataProviders: SamlIdentityProviderStatus[] = samlData.providers.map((s) => {
        let primarySAML: SamlIdentityProviderConfig = s.provider.config.find((c) => isActiveServer(c.entityId));
        let secondarySAML: SamlIdentityProviderConfig = s.provider.config.find((c) => !isActiveServer(c.entityId));
        if (!primarySAML) {
            primarySAML = s.provider.config[0];
            primarySAML = { ...primarySAML, entityId: getIdentityID(getGlobalStates().host) };
            if (s.provider.config.length > 1) secondarySAML = s.provider.config[1];
            let updatedConfig: SamlIdentityProviderConfig[] = [];
            updatedConfig.push(primarySAML);
            if (s.provider.config.length > 1) updatedConfig.push(secondarySAML);
            return {
                ...s,
                provider: { ...s.provider, config: updatedConfig },
                error: true,
                errorKey: "INVALID_SAML_CONFIG" as IDENTITY_PROVIDER_ERROR_KEY,
                errorMassage: "",
            };
        }
        return s;
    });
    const updatedStatus: SamlIdentityProviders = { providers: updatedSAMLDataProviders };
    return updatedStatus;
};
